<script>
    export let title;
</script>


<section>
    <div class="section-heading">
        <h1>{title}</h1>
        <slot name="button">
        </slot>
    </div>
    <slot></slot>
</section>

<style>
    .section-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.5rem;
        gap: 1rem;
        height: 2rem;
    }

    h1 {
        margin: 0;
    }

    /* the following styles should probably be global */

    h1 {
        color: rgba(0, 0, 0, 0.8);
    }

    section {
        padding: 2rem 0 3rem;
    }

    /* .section-heading>:global(button) {
        color: #666;
        background-color: #F0F0F0;
        border: transparent;
        border-radius: 0.5rem;
        padding: 0 1rem;
        line-height: 2rem;
        margin: 0;
    } */
</style>